import { useRoutes } from 'react-router-dom'

import Home from '@/views/Home/index'
import Login from '@/views/Auth/Login'
import ApplyCandidateForm from '@/views/Job/add-candidate';
import ApplyCandidateFormBulk from '@/views/Job/bulk-upload';
import JobDetails from '@/views/Job/job-details'
import BulkImportTable from '@/views/Job/import-table';
import CandidateList from '@/views/Job/candidate-list';
import PrivateRoute from '@/components/PrivateRoute'

export default function Router() {
  return useRoutes([
    {
      path: '/',
      element: <Navigate to="/jobs" replace />,
      
    },
    {
      path: '/home',
      element: <Navigate to="/jobs" replace />,
    },
    {
      path: '/jobs',
      element: <PrivateRoute element={<Home />} />,
    },
    {
      path: '/login',
      element: <Login />,
    },
    {
      path: '/job/:id',
      element: <PrivateRoute element={<JobDetails />} />,
    },
    {
      path: '/job/:id/add-candidate',
      element: <PrivateRoute element={<ApplyCandidateForm />} />,
    },
    {
      path: '/add-bulk-candidates',
      element: <PrivateRoute element={<ApplyCandidateFormBulk />} />,
    },
    {
      path: '/list-bulk-candidates',
      element: <PrivateRoute element={<BulkImportTable />} />,
    },
    {
      path: '/candidates',
      element: <PrivateRoute element={<CandidateList />} />,
    },
  ])
}
